import { Button, styled, Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';

export const FooterW = styled('div')`
  margin-top: 32px;
  display: flex;
  justify-content: space-between;
  white-space: break-spaces;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p050};
`;

export const ResetPasswordButton = styled(Button)`
  width: 100%;
  height: 50px;
  border-radius: 4px;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: none;

  &:hover {
    box-shadow: none;
  }
`;

export const SignUpHint = styled(Typography)`
  font-size: 15px;
  color: ${({ theme }) => theme.palette.primary.p080};

  @media (min-width: 1023px) {
    padding-bottom: 24px;
  }
`;

export const LinkW = styled(NavLink)`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.info.main};
  cursor: pointer;
  text-decoration: none;
`;
